import { useEffect } from 'react';
import { useAppStore } from '../store/appStore';

export function useFridayKahf(navigate: (path: string) => void) {
  const kahfReminder = useAppStore((s) => s.settings.kahf_reminder);
  const friday = useAppStore((s) => s.friday);

  useEffect(() => {
    if (!kahfReminder) return;

    const today = new Date();
    if (today.getDay() !== 5) return;

    const todayStr = today.toDateString();
    if (String(friday) === todayStr) return;

    const confirmed = window.confirm(
      "Today is Friday! Would you like to read Surah Al-Kahf?"
    );
    if (confirmed) {
      navigate('/18/1-20');
    }
    useAppStore.setState({ friday: todayStr });
  }, [kahfReminder, friday, navigate]);
}
